<template>
  <div id="app">
    <div id="container">
      <header>
        <h1 id="logo">
          <router-link to="/">
            <img src="/images/title.png">
          </router-link>
        </h1>
      </header>
      <!--PC用（801px以上端末）メニュー-->
      <nav id="menubar">
        <ul>
          <li v-for="menu in menuList" :key="menu.id">
            <router-link :to="menu.menuURL"> {{ menu.menuName }} <span>{{ menu.menuNameEnglish }}</span>
            </router-link>
          </li>
        </ul>
      </nav><!--/menubar-->
      <!--小さな端末用（800px以下端末）メニュー-->
      <nav id="menubar-s">
        <ul>
          <li v-for="menu in menuList" :key="menu.id">
            <router-link :to="menu.menuURL"> {{ menu.menuName }} <span>{{ menu.menuNameEnglish }}</span>
            </router-link>
          </li>
        </ul>
      </nav><!--/menubar-s-->
      <router-view />
      <div class="modal-wrapper"><img src="null" alt="" class="modal-image"></div>
      <footer class="footer">
        <div class="md-flex md-justify-between">
          <p class="copyright">© 2024 たちかわ演劇祭実行委員会 </p>
          <div class="footer__social">
            <a href="https://www.facebook.com/profile.php?id=100093022203013" class="facebook">
              <svg fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" class="w-5 h-5">
                <path fill-rule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clip-rule="evenodd">
                </path>
              </svg>
            </a>
            <a href="https://www.instagram.com/tachikawa_pinta/?igshid=OGQ5ZDc2ODk2ZA==" class="instagram">
              <svg fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" class="w-5 h-5">
                <path fill-rule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clip-rule="evenodd">
                </path>
              </svg>
            </a>
          </div>
        </div>
      </footer>
    </div><!--/container-->
    <!--「↑」ボタン-->
    <p class="nav-fix-pos-pagetop">
      <a href="#">↑</a>
    </p>
    <!-- メニュー開閉ボタン -->
    <div v-on:click="do_onoff('menubar_hdr', 'menubar-s')" id="menubar_hdr" class="close"></div>
    <!-- メニューの開閉処理条件設定 800px以下 -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: "App",
  computed: {
    menuList() {
      return this.$store.getters.getMenuList;
      // return this.$store.getters["database"];
    },
    OCwindowWidth() {
      if (window.screen.width < window.innerWidth) {
        return window.screen.width;
      }
      return window.innerWidth;
    },
    // },
    // computed: {
    ...mapGetters({
      pageTitle: 'common/pageTitle',
    }),
  },
  filters: {
    addComma: function (value) {
      return value.toLocaleString();
    },
    addNewLine: function (value) {
      return value.replace(/\r?\n/g, '<br>');
    },
    convertBullet: function (value) {
      return '<ul><li>' + value.replace(/\r?\n/g, '</li><li>') + '</li></ul>';
    },
  },
  data() {
    return {};
  },
  methods: {
    do_onoff: function (hdr, item) {
      // console.log('methods/do_onoff');
      var e = document.getElementById(hdr);
      var e2 = document.getElementById(item);
      if (e2.style.display == "none") {
        e2.style.display = "";
        classList(e).remove("close");
        classList(e).add("open");
      } else {
        e2.style.display = "none";
        classList(e).remove("open");
        classList(e).add("close");
      }
    },
    open_close: function (hdr, item) {
      // console.log('methods/open_close');
      var e = document.getElementById(hdr);
      // console.log(e);
      var e2 = document.getElementById(item);
      // console.log(e2);
      e.addEventListener(
        "click",
        function () {
          this.do_onoff(hdr, item);
        },
        false
      );

      classList(e).remove("open");
      classList(e).add("close");
      if (classList(e).contains("open")) {
        //		e.style.display = '';
        e2.style.display = "";
      }
      if (classList(e).contains("close")) {
        //		e.style.display = '';
        e2.style.display = "none";
      }
    },
    classList: function (e) {
      if (e.classList) return e.classList;
      // Return e.classList if it exists
      else return new CSSClassList(e); // Otherwise try to fake it
    },
    CSSClassList: function (e) {
      this.e = e;
    },
    image_modal: function () {
      console.log('<image_modal>')
      var modalWrapper = document.querySelector(".modal-wrapper");
      console.log(modalWrapper)
      var zoomElement = document.querySelectorAll(".zoom");
      console.log(zoomElement)

      var modalImage = document.querySelector(".modal-image");
      console.log(modalImage)

      zoomElement.forEach((function (zoomElement) {
        console.log('<forEach>')
        zoomElement.addEventListener("click", (function () {
          var zoomElementSrc = zoomElement.getAttribute("src");
          modalImage.src = zoomElementSrc;
          modalWrapper.classList.add("show");
          modalImage.classList.add("show");
        }
        ))
      }
      )),
        modalWrapper.addEventListener("click", (function () {
          this.classList.contains("show") && (this.classList.remove("show"), modalImage.classList.remove("show")),
          modalImage.src = null
        }
        ))
    },
    //   addTodo() {
    //     this.$store.dispatch(ADD_TODO, this.todoText);
    //     this.todoText = '';
    //   },
    //   removeTodo(key) {
    //     this.$store.dispatch(REMOVE_TODO, key);
    //   },
    // },
  },
  beforeMount: function () {
    // document.title = "たちかわ演劇祭";
    // console.log('pageTitle')
    // console.log(this.pageTitle)
    document.title = this.pageTitle;
  },
  mounted: function () {
    console.log('<mounted>')
    document.title = this.pageTitle;
    if (OCwindowWidth() <= 800) {
      // console.log('OCwindowWidth() <= 800')
      // open_close("menubar_hdr", "menubar-s");
      this.open_close("menubar_hdr", "menubar-s");
    }
    setTimeout(this.image_modal(), 5000);
    console.log('</mounted>')
  },
  updated: function () {
    // console.log('<updated>')
    if (OCwindowWidth() <= 800) {
      this.open_close("menubar_hdr", "menubar-s");
    }
    this.image_modal();
    // console.log('</updated>')
  },
};

/*-----------------------------------------------------------------------------
 * Return the classList property of e, if it has one.
 * Otherwise, return an object that simulates the DOMTokenList API for e.
 * The returned object has contains(), add(), remove(), toggle() and toString()
 * methods for testing and altering the set of classes of the element e.
 * If the classList property is natively supported, the returned object is
 * array-like and has length and array index properties. The simulated
 * DOMTokenList is not array-like, but has a toArray() method that returns
 * a true-array snapshot of the element's class names.
 */

function classList(e) {
  if (e.classList) return e.classList;
  // Return e.classList if it exists
  else return new CSSClassList(e); // Otherwise try to fake it
}

// CSSClassList is a JavaScript class that simulates DOMTokenList
function CSSClassList(e) {
  this.e = e;
}

// Return true if e.className contains the class c, false otherwise
CSSClassList.prototype.contains = function (c) {
  // Check that c is a valid class name
  if (c.length === 0 || c.indexOf(" ") != -1)
    throw new Error("Invalid class name: '" + c + "'");
  // Check common cases first
  var classes = this.e.className;
  if (!classes) return false; // e has no classes at all
  if (classes === c) return true; // e has one class that matches exactly

  // Otherwise, use a RegExp to search for c as a word by itself
  // \b in a regular expression requires a match at a word boundary.
  return classes.search("\\b" + c + "\\b") != -1;
};

// Add c to the e.className if it is not already present
CSSClassList.prototype.add = function (c) {
  if (this.contains(c)) return; // Do nothing if already present
  var classes = this.e.className;
  if (classes && classes[classes.length - 1] != " ") c = " " + c; // Add a space if we need one
  this.e.className += c; // Add c to the className
};

// Remove all occurrences of c from e.className
CSSClassList.prototype.remove = function (c) {
  // Make sure c is a valid class name
  if (c.length === 0 || c.indexOf(" ") != -1)
    throw new Error("Invalid class name: '" + c + "'");
  // Remove all occurances of c as a word, plus any trailing space
  var pattern = new RegExp("\\b" + c + "\\b\\s*", "g");
  this.e.className = this.e.className.replace(pattern, "");
};

// Add c to e.className if it is not already present and return true.
// Otherwise, remove all occurrences of c from e.className and return false.
CSSClassList.prototype.toggle = function (c) {
  if (this.contains(c)) {
    // If e.className contains c
    this.remove(c); // then remove it.
    return false;
  } else {
    // Otherwise:
    this.add(c); // add it.
    return true;
  }
};

// Return e.className itself
CSSClassList.prototype.toString = function () {
  return this.e.className;
};

// Return of the names in e.className
CSSClassList.prototype.toArray = function () {
  return this.e.className.match(/\b\w+\b/g) || [];
};
// function do_onoff(hdr, item) {
//   console.log('do_onoff');
//   var e = document.getElementById(hdr);
//   var e2 = document.getElementById(item);
//   if (e2.style.display == "none") {
//     e2.style.display = "";
//     classList(e).remove("close");
//     classList(e).add("open");
//   } else {
//     e2.style.display = "none";
//     classList(e).remove("open");
//     classList(e).add("close");
//   }
// }
// function open_close(hdr, item) {
//   console.log('open_close');
//   var e = document.getElementById(hdr);
//   console.log(e);
//   var e2 = document.getElementById(item);
//   console.log(e2);
//   e.addEventListener(
//     "click",
//     function() {
//       do_onoff(hdr, item);
//     },
//     false
//   );
//   classList(e).remove("open");
//   classList(e).add("close");
//   if (classList(e).contains("open")) {
//     //		e.style.display = '';
//     e2.style.display = "";
//   }
//   if (classList(e).contains("close")) {
//     //		e.style.display = '';
//     e2.style.display = "none";
//   }
// }
// function OCisSmartPhone() {
//   return (
//     (navigator.userAgent.indexOf("iPhone") > 0 &&
//       navigator.userAgent.indexOf("iPad") == -1) ||
//     navigator.userAgent.indexOf("iPod") > 0 ||
//     navigator.userAgent.indexOf("Android") > 0
//   );
// }
// function OCdisplayWidth() {
//   return window.parent.screen.width;
// }
function OCwindowWidth() {
  if (window.screen.width < window.innerWidth) {
    return window.screen.width;
  }
  return window.innerWidth;
}
// if (OCwindowWidth() <= 800) {
//   open_close("menubar_hdr", "menubar-s");
// }

/*-----------------------------------------------------------------------------
*/
function fm_hasClass(e, c) {
  var classes = e.className;
  if (!classes) return false;
  if (classes === c) return true;
  return classes.search("\\b" + c + "\\b") != -1;
}
function fm_addClass(e, c) {
  if (fm_hasClass(e, c)) return;
  var classes = e.className;
  if (classes && classes[classes.length - 1] != " ") c = " " + c;
  e.className += c;
}
function fm_removeClass(e, c) {
  var pattern = new RegExp("\\b" + c + "\\b\\s*", "g");
  e.className = e.className.replace(pattern, "");
}
function fm_addEvent(elm, listener, fn) {
  try {
    elm.addEventListener(listener, fn, false);
  } catch (e) {
    elm.attachEvent("on" + listener, fn);
  }
}
fm_addEvent(window, "load", function () {
  var offsettop;
  offsettop = 350;
  fm_addEvent(window, "scroll", function () {
    if (
      offsettop <
      Math.max(document.body.scrollTop, document.documentElement.scrollTop)
    ) {
      fm_addClass(document.body, "is-fixed-pagetop");
    }
    if (
      offsettop - 50 >
      Math.max(document.body.scrollTop, document.documentElement.scrollTop)
    ) {
      fm_removeClass(document.body, "is-fixed-pagetop");
    }
  });
});
</script>
<style>
@charset "utf-8";

/*全端末（PC・タブレット・スマホ）共通設定
------------------------------------------------------------------------------------------------------------------------------------------------------*/

/*全体の設定
---------------------------------------------------------------------------*/
html {
  scroll-behavior: smooth;
}

body {
  margin: 0px;
  padding: 0px;
  color: #666;
  /*全体の文字色*/
  font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ",
    Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  /*フォント種類*/
  font-size: 15px;
  /*文字サイズ*/
  line-height: 2;
  /*行間*/
  background: #eee url(../public/images/bg.png);
  /* background: url("../public/images/bg_2019.png") repeat center; */
  /*背景色、背景画像の読み込み*/
  -webkit-text-size-adjust: none;
}

h1,
h2,
h3,
h4,
h5,
p,
ul,
ol,
li,
dl,
dt,
dd,
form,
figure,
form {
  margin: 0px;
  padding: 0px;
  font-size: 100%;
  font-weight: normal;
}

ul {
  list-style-type: none;
}

ol {
  padding-left: 40px;
  padding-bottom: 15px;
}

img {
  border: none;
  max-width: 100%;
  height: auto;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
  font-size: 100%;
  border-spacing: 0;
}

iframe {
  width: 100%;
}

/*リンク（全般）設定
---------------------------------------------------------------------------*/
a {
  color: #666;
  /*リンクテキストの色*/
  transition: 0.5s;
  /*マウスオン時の移り変わるまでの時間設定。0.5秒。*/
}

a:hover {
  color: #0e36ca;
  /*マウスオン時の文字色*/
  text-decoration: none;
  /*マウスオン時に下線を消す設定。残したいならこの１行削除。*/
}

/*containerブロック
---------------------------------------------------------------------------*/
#container {
  border-top: 5px solid #0e36ca;
  /*上の線の幅、線種、色*/
  margin: 0 auto;
  max-width: 1200px;
  /*サイトの最大幅*/
  background: #fff;

  /*背景色*/
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  /*ボックスの影。右に、下に、広げる幅。0,0,0は黒の事で0.2は透明度20%の事。*/
}

/*ヘッダー（ロゴが入った最上段のブロック）
---------------------------------------------------------------------------*/
/*ヘッダーブロック*/
header {
  background: url(../public/images/bg_2019.png);
  overflow: hidden;
  height: 100px;
  /*ブロックの高さ*/
}

/*ロゴ画像*/
header #logo img {
  width: 300px;
  /*画像幅*/
  float: left;
  /*左に回り込み*/
  margin-top: 36px;
  /*上下のバランスをとって下さい*/
  margin-left: 4%;
  /*左に空けるスペース*/
}

/*メインメニュー
---------------------------------------------------------------------------*/
/*メニューブロック*/
#menubar {
  overflow: hidden;
  border-top: 1px solid #d2d2d2;
  /*上の線の幅、線種、色*/
  border-bottom: 1px solid #d2d2d2;
  /*下の線の幅、線種、色*/
}

/*メニュー１個あたりの設定*/
#menubar li {
  float: left;
  /*左に回り込み*/
  line-height: 1.6;
  /*行間*/
  width: 16.6%;
  /*幅*/
}

#menubar li a {
  display: block;
  text-decoration: none;
  position: relative;
  text-align: center;
  /*文字をセンタリング*/
  padding: 12px 0px;
  /*上下、左右へのボックス内の余白*/
  border-left: 1px solid #d2d2d2;
  /*左側の線の幅、線種、色*/
  font-weight: bold;
  /*太字にする設定*/
}

/*１つ目のメニューへの追加設定*/
#menubar li:first-child {
  width: 17%;
  /*幅。６個メニューなので、16.6で割り切れない分をここで再設定。*/
}

#menubar li:first-child a {
  border-left: none;
  /*左側の線を消す設定*/
}

/*英語表記（飾り文字）*/
#menubar li a span {
  display: block;
  font-size: 9px;
  /*文字サイズ*/
  color: #bababa;
  /*文字色*/
  font-weight: normal;
  /*太字を標準に戻す設定*/
  letter-spacing: 0.2em;
  /*文字間隔を少し広くする設定*/
}

/*マウスオン時と、現在表示中メニューの設定*/
#menubar li a:hover,
#menubar li.current a {
  background: #e6ebfa;
  /*背景色*/
}

/*左側のアクセントライン*/
#menubar li a:hover::before,
#menubar li.current a::before {
  content: "";
  position: absolute;
  left: 5px;
  width: 3px;
  height: 40px;
  background: linear-gradient(#1244ff, #0e36ca);
  /*グラデーション*/
}

/*スマホ用メニューを表示させない*/
#menubar-s {
  display: none;
}

/*３本バーアイコンを表示させない*/
#menubar_hdr {
  display: none;
}

/* intor voices */

.voices {
  background: #f8f8f8;
  margin: 10px 10px 10px 10px;
}

.voices .flex {
  display: flex;
  justify-content: space-between;
}

.voice {
  width: 250px;
  background: #fff;
  position: relative;
  box-sizing: border-box;
  padding: 60px 40px 25px;
}

.voice img {
  border-radius: 50%;
  border: 10px solid #fff;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: -55px;
}

.voice h1 {
  text-align: center;
  font-size: 18px;
  font-weight: normal;
}

.voices .section-title {
  margin-bottom: 95px;
}

/*コンテンツ（mainとsubを囲むブロック）
---------------------------------------------------------------------------*/
#contents {
  clear: both;
  overflow: hidden;
  padding: 3%;
  /*ボックス内の余白*/
}

#contents.home {
  padding: 0
}

/*mainコンテンツ
---------------------------------------------------------------------------*/
#main {
  float: left;
  /*左に回り込み*/
  width: 72%;
  /*幅*/
}

#main.home {
  width: 100%
}

/*１カラム利用時の設定*/
.c1 #main {
  float: none;
  width: auto;
}

/*h2タグの設定*/
#main h2 {
  font-size: 1.8rem;
  padding: 5px 20px;
  background: #240eca;
  background: linear-gradient(-45deg, #240eca, #4a0eca 20%, #2268a1 80%);
  -webkit-box-shadow: 1px 2px 5px #ccc;
  box-shadow: 1px 2px 5px #ccc;
  color: #fff;
  border-radius: 4px
}

#main h2,
#main h3 {
  clear: both;
  margin-bottom: 20px;
  font-weight: 700
}

#main h3 {
  font-size: 1.3rem;
  padding: 6px 20px;
  border: 1px solid #ccc;
  border-radius: 4px
}

#main h4 {
  margin-bottom: 1rem;
  font-size: 1.3rem;
  padding-left: 20px;
  line-height: 150%
}

#main p {
  padding: 0 20px 15px
}

/*h2タグの１文字目の設定*/
/* #main h2::first-letter { */
  /* border-left: 3px solid rgba(255, 255, 255, 0.5); */
  /* padding-left: 20px; */
/* } */

/*h3タグの設定*/
#main h3 {
  /* clear: both; */
  /* margin-bottom: 20px; */
  /* font-size: 18px; */
  font-size: 1.3rem;
  padding: 6px 20px;
  /* background: linear-gradient(#fff, #eee); */
  border: 1px solid #ccc;
  border-radius: 4px;
}

/*段落タグ設定*/
#main p {
  padding: 0px 20px 15px;
  /*上、左右、下への余白*/
}

#main h2+p,
#main h3+p {
  margin-top: -10px;
}

#main section+section {
  margin-top: 50px;
}

#mainimg img {
  padding: 0px 0px 0px;
  /*上、左右、下への余白*/
}

#main.contentimg {
  padding: 0px 20px 15px;
  /*上、左右、下への余白*/
}

/*ボックス（list）設定
---------------------------------------------------------------------------*/
/*ボックス１個あたりの設定*/
#main .list {
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  /*ボックス同士の上下間の余白*/
  border: 1px solid #ccc;
  /*枠線の幅、線種、色*/
  padding: 20px;
  /*ボックス内の余白。変更する際は、下の「#main .list a」のmarginとpaddingの数字も変更する。*/
  background: linear-gradient(#fff, #eee);
  /*グラデーション*/
  box-shadow: 0px 2px 5px #ccc;
  /*影の設定。右・下・ぼかし幅・色の設定*/
}

#main .list a {
  overflow: hidden;
  display: block;
  text-decoration: none;
  margin: -20px;
  /*ボックス内の余白。変更する際は、上の「#main .list」のpaddingの数字も変更する。※必ずマイナス記号をつけておく。*/
  padding: 20px;
  /*ボックス内の余白。変更する際は、上の「#main .list」のpaddingの数字も変更する。*/
  background: linear-gradient(#fff, #eee);
  /*グラデーション*/
}

/*マウスオン時設定*/
#main .list a:hover {
  background: #fff;
  /*マウスオン時の背景色*/
}

/*ボックスにリンク指定がされた場合に出る「→」マーク*/
#main .list a::before {
  content: "→";
  /*この文字を出す。他の文字に変えても可だが機種依存文字は化けるので使わない。*/
  position: absolute;
  right: 20px;
  /*ボックスの右から20pxの場所に配置*/
  top: 20px;
  /*ボックスの上から20pxの場所に配置*/
  background: #999;
  /*背景色（古いブラウザ用）*/
  background: rgba(0, 0, 0, 0.5);
  /*rgb指定での背景色。「0,0,0」は黒の事で「0.5」が透明度50%の事。*/
  color: #fff;
  /*文字色*/
  border: 1px solid #fff;
  /*枠線の幅、線種、色*/
  border-radius: 4px;
  /*角丸のサイズ*/
  width: 30px;
  /*幅*/
  line-height: 30px;
  /*高さ*/
  text-align: center;
}

#main .list a:hover::before {
  background: #000;
  /*マウスオン時の「→」マークの背景色*/
}

/*ボックス内の画像設定*/
#main .list .img {
  width: 30%;
  /*画像の幅*/
  float: left;
  margin-right: 10px;
}

/*ボックス内のh4（見出し）タグ設定*/
#main .list h4 {
  font-size: 18px;
  /*文字サイズ*/
  color: #0e36ca;
  /*文字色*/
}

/*ボックス内のp（段落）タグ設定*/
#main .list p {
  padding: 0;
}

/*subコンテンツ
---------------------------------------------------------------------------*/
/*subブロック*/
#sub {
  float: right;
  /*右に回り込み*/
  width: 24%;
  /*幅*/
}

/*１カラム利用時の設定*/
.c1 #sub {
  display: none;
  /*非表示にする*/
}

/*subコンテンツ内のh2タグ設定*/
#sub h2 {
  padding: 15px 10px;
  /*左から、上下、左右への余白*/
  background: #eee;
  /*背景色*/
  border-bottom: 1px solid #d2d2d2;
  /*下の線の幅、線種、色*/
  border-top: 5px solid #0e36ca;
  /*上の線の幅、線種、色*/
  font-weight: bold;
  /*太字にする設定*/
}

/*subコンテンツのbox
---------------------------------------------------------------------------*/
#sub .box {
  border: 1px solid #d2d2d2;
  /*枠線の幅、線種、色*/
  padding: 10px;
  /*ボックス内の余白*/
  margin-bottom: 20px;
  /*ボックスの下に空けるスペース*/
  background: linear-gradient(#fff, #eaeaea);
  /*グラデーション*/
  box-shadow: 0px 0px 0px 1px #fff inset;
  /*内側への影を右・下・ぼかし幅・距離・色を設定*/
}

/*subコンテンツ内のメニュー
---------------------------------------------------------------------------*/
/*メニュー全体の設定*/
#sub ul.submenu {
  margin-bottom: 20px;
  /*ブロックの下に空けるスペース*/
}

/*メニュー１個ごとの設定*/
#sub ul.submenu li a {
  text-decoration: none;
  display: block;
  padding: 5px 10px;
  /*メニュー内の余白。上下、左右への設定。*/
  border-bottom: 1px solid #d2d2d2;
  /*下の線の幅、線種、色*/
}

/*マウスオン時の背景色*/
#sub ul.submenu li a:hover {
  background: #fff;
}

/*box内のメニューブロックの設定*/
#sub .box ul.submenu {
  margin-bottom: 0;
}

/*サブコンテンツ内の一覧ブロック
---------------------------------------------------------------------------*/
/*各ボックスの設定*/
#sub .list {
  position: relative;
  overflow: hidden;
  font-size: 11px;
  /*文字サイズ*/
  line-height: 1.2;
  /*行間を狭くする*/
}

#sub .list a {
  text-decoration: none;
  display: block;
  overflow: hidden;
  padding: 10px;
  /*ボックス内の余白*/
  border-bottom: 1px solid #d2d2d2;
  /*下の線の幅、線種、色*/
}

/*マウスオン時*/
#sub .list a:hover {
  background: #fff;
  /*背景色*/
}

/*ボックス内のh4タグ設定*/
#sub .list h4 {
  color: #0e36ca;
  /*文字色*/
}

/*ボックス内の写真設定*/
#sub .list figure img {
  float: left;
  /*画像を左へ回り込み*/
  width: 20%;
  /*写真の幅*/
  margin-right: 5px;
  /*写真の右側に空ける余白*/
}

/*フッター設定
---------------------------------------------------------------------------*/
footer {
  clear: both;
  text-align: center;
  padding: 10px 0;
  background: #0e36ca;
  color: #fff
}

footer a {
  text-decoration: none;
  color: #fff
}

footer .pr {
  display: block;
  font-size: 80%;
}

/*トップページ内「更新情報・お知らせ」ブロック
---------------------------------------------------------------------------*/
/*ブロック全体の設定*/
#new dl {
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 20px;
}

/*日付設定*/
#new dt {
  float: left;
  width: 9em;
  /*幅*/
  color: #0e36ca;
  /*文字色*/
  letter-spacing: 0.1em;
}

/*記事設定*/
#new dd {
  padding-left: 9em;
  border-bottom: 1px solid #ccc;
  /*下線の幅、線種、色*/
}

/*テーブル（ta1）
---------------------------------------------------------------------------*/
/*ta1設定*/
.ta1 {
  width: 100%;
  margin: 0 auto 20px;
}

.ta1,
.ta1 td,
.ta1 th {
  border: 1px solid #ccc;
  /*テーブルの枠線の幅、線種、色*/
  padding: 10px 15px;
  /*ボックス内の余白*/
  word-break: break-all;
}

/*テーブル１行目に入った見出し部分*/
.ta1 th.tamidashi {
  width: auto;
  text-align: left;
  /*左よせ*/
}

/*ta1の左側ボックス*/
.ta1 th {
  width: 140px;
  /*幅*/
  text-align: center;
  /*センタリング*/
  font-weight: normal;
}

/*左側ボックスに画像を入れた場合の設定*/
.ta1 th img {
  width: 100%;
}

/*inputボタン
---------------------------------------------------------------------------*/
#main input[type="submit"].btn,
#main input[type="button"].btn,
#main input[type="reset"].btn {
  padding: 5px 10px;
  border: 1px solid #ccc;
  font-size: 15px;
  border-radius: 3px;
  background: linear-gradient(#fff, #eee);
}

/*マウスオン時の設定*/
#main input[type="submit"].btn:hover,
#main input[type="button"].btn:hover,
#main input[type="reset"].btn:hover {
  border: 1px solid #999;
  background: #fff;
}

/*トップページのNEWアイコン
---------------------------------------------------------------------------*/
.newicon {
  background: #f00;
  /*背景色*/
  color: #fff;
  /*文字色*/
  font-size: 70%;
  /*文字サイズ*/
  line-height: 1.5;
  padding: 2px 5px;
  border-radius: 2px;
  margin: 0px 5px;
  vertical-align: text-top;
}

/*その他
---------------------------------------------------------------------------*/
.look {
  background: #ccc;
  color: #333;
  padding: 5px 10px;
  border-radius: 4px;
}

.mb15,
.mb1em {
  margin-bottom: 15px !important;
}

.mb30 {
  margin-bottom: 30px !important;
}

.p0 {
  padding: 0 !important;
}

.clear {
  clear: both;
}

ul.disc {
  padding: 0em 25px 15px;
  list-style: disc;
}

.color1,
.color1 a {
  color: #f00;
}

.bg1 {
  background: #f6f5f2;
}

.pr {
  font-size: 10px;
}

.wl {
  width: 96%;
}

.ws {
  width: 50%;
}

.c {
  text-align: center;
}

.r {
  text-align: right;
}

.l {
  text-align: left;
}

img.fr {
  float: right;
  margin-left: 10px;
  margin-bottom: 10px;
}

img.fl {
  float: left;
  margin-right: 10px;
  margin-bottom: 10px;
}

.big1 {
  font-size: 20px;
}

.mini1 {
  font-size: 11px;
  display: inline-block;
  line-height: 1.5;
}

.sh {
  display: none;
}

/*画面幅800px以下の設定
------------------------------------------------------------------------------------------------------------------------------------------------------*/
@media screen and (max-width: 800px) {
  header {
    margin-bottom: 14px;
  }

  /*コンテンツ（mainとsubを囲むブロック）
---------------------------------------------------------------------------*/
  #contents {
    /* padding: 0 3%; */
    /*ボックス内の余白。上下、左右。*/
  }

  /*メインメニュー
---------------------------------------------------------------------------*/
  /*アニメーションのフレーム設定。全100コマアニメーションだと思って下さい。透明度(opacity)0%から透明度100%にする指定。*/
  @keyframes menu1 {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  /*スマホ用メニューブロック*/
  #menubar-s {
    /* display: none; */
    display: block;
    overflow: hidden;
    position: absolute;
    top: 105px;
    /*上から105pxの場所に配置*/
    border-top: 1px solid #fff;
    /*上の線の幅、線種、色*/
    width: 100%;
    z-index: 10;
    animation-name: menu1;
    /*上のkeyframesの名前*/
    animation-duration: 0.5s;
    /*アニメーションの実行時間。0.5秒。*/
    animation-fill-mode: both;
    /*アニメーションの完了後、最後のキーフレームを維持する*/
  }

  /*メニュー１個あたりの設定*/
  #menubar-s li a {
    display: block;
    text-decoration: none;
    padding: 15px 10px 15px 20px;
    /*上、右、下、左へのメニュー内の余白*/
    border-bottom: 1px solid #fff;
    /*下の線の幅、線種、色*/
    background: #000;
    /*背景色*/
    background: rgba(0, 0, 0, 0.8);
    /*背景色。0,0,0は黒の事で0.8は透明度80%の事。*/
    color: #fff;
    /*文字色*/
    font-size: 20px;
    /*文字サイズ*/
  }

  /*英語表記（飾り文字）*/
  #menubar-s li a span {
    display: block;
    font-size: 12px;
    /*文字サイズ*/
  }

  /*PC用メニューを非表示にする*/
  #menubar {
    display: none;
  }

  /*３本バーアイコン設定
---------------------------------------------------------------------------*/
  /*３本バーブロック*/
  #menubar_hdr {
    display: block;
    position: absolute;
    top: 28px;
    /*上から28pxの場所に配置*/
    right: 3%;
    /*右から3%の場所に配置*/
    border: 1px solid #000;
    /*枠線の幅、線種、色*/
  }

  /*アイコン共通設定*/
  #menubar_hdr.close,
  #menubar_hdr.open {
    width: 50px;
    /*幅*/
    height: 50px;
    /*高さ*/
  }

  /*三本バーアイコン*/
  #menubar_hdr.close {
    background: #fff url(../public/images/icon_menu.png) no-repeat center top/50px;
  }

  /*閉じるアイコン*/
  #menubar_hdr.open {
    background: #fff url(../public/images/icon_menu.png) no-repeat center bottom/50px;
  }

  /*main,subコンテンツ
---------------------------------------------------------------------------*/
  #main,
  #sub {
    float: none;
    width: auto;
  }

  /*その他
---------------------------------------------------------------------------*/
  body.s-n #sub,
  body.s-n #footermenu,
  .m-n {
    display: none;
  }
}

/*画面幅480px以下の設定
------------------------------------------------------------------------------------------------------------------------------------------------------*/
@media screen and (max-width: 480px) {

  /*ヘッダー（ロゴが入った最上段のブロック）
---------------------------------------------------------------------------*/
  /*ロゴ画像*/
  header #logo img {
    width: 200px;
    /*画像幅*/
    margin-top: 40px;
    /*上下のバランスをとって下さい*/
  }

  /*全体の設定
---------------------------------------------------------------------------*/
  body {
    font-size: 12px;
    /*文字サイズ*/
    line-height: 1.5;
    /*行間*/
  }

  /*mainコンテンツ
---------------------------------------------------------------------------*/
  #main h2,
  #main h3 {
    font-size: 14px;
    padding-left: 10px;
    padding-right: 10px;
  }

  /*h2タグの１文字目の設定*/
  #main h2::first-letter {
    padding-left: 8px;
    /*線とテキストとの余白*/
  }

  /*段落タグ設定*/
  #main p {
    padding: 0px 10px 15px;
    /*上、左右、下への余白*/
  }

  /*ボックス（list）設定
---------------------------------------------------------------------------*/
  /*ボックス内のh4（見出し）タグ設定*/
  #main .list h4 {
    font-size: 14px;
    /*文字サイズ*/
  }

  /*トップページ内「更新情報・お知らせ」ブロック
---------------------------------------------------------------------------*/
  /*ブロック全体の設定*/
  #new dl {
    padding-left: 10px;
    padding-right: 10px;
  }

  /*テーブル（ta1）
---------------------------------------------------------------------------*/
  /*ta1設定*/
  .ta1,
  .ta1 td,
  .ta1 th {
    padding: 5px;
    /*ボックス内の余白*/
  }

  /*ta1の左側ボックス*/
  .ta1 th {
    width: 100px;
  }

  /*その他
---------------------------------------------------------------------------*/
  .ws,
  .wl {
    width: 94%;
  }

  .big1 {
    font-size: 16px;
  }

  img.fr,
  img.fl {
    float: none;
    margin: 0;
    width: 100%;
  }

  .sh {
    display: block;
  }

  .pc {
    display: none;
  }
}

/* @charset "utf-8"; */

@keyframes scroll {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

body .nav-fix-pos-pagetop a {
  display: none;
}

body.is-fixed-pagetop .nav-fix-pos-pagetop a {
  display: block;
  text-decoration: none;
  text-align: center;
  width: 50px;
  line-height: 50px;
  z-index: 100;
  position: fixed;
  bottom: 100px;
  right: 3%;
  background: #000;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border: 1px solid #fff;
  animation-name: scroll;
  /*上のアニメーションで指定しているkeyframesの名前（scroll）*/
  animation-duration: 1s;
  /*アニメーションの実行時間*/
  animation-fill-mode: forwards;
  /*アニメーションの完了後、最後のキーフレームを維持する*/
}

body.is-fixed-pagetop .nav-fix-pos-pagetop a:hover {
  background: #999;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem
}

.footer {
  margin-top: 2rem;
  padding: 2rem;
  font-size: 15px;
  color: #fff;
  background: #240eca;
  background: linear-gradient(-45deg, #240eca, #4a0eca 30%, #2268a1 80%)
}

.footer__navi-heading {
  font-weight: 600
}

.footer__logo {
  display: inline-block;
  margin-bottom: 2rem
}

.footer__navi li {
  margin-bottom: .75rem
}

.footer__social a {
  display: inline-block;
  width: 24px;
  opacity: .7
}

.footer__social a:not(:last-child) {
  margin-right: 16px
}

@media (min-width: 768px) {
  .md-flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex
  }

  .md-justify-between {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between
  }

  .grid {
    grid-template-columns: repeat(3, minmax(0, 1fr))
  }
}

.modal-wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, .5);
  pointer-events: none;
  opacity: 0;
  -webkit-transition: .25s ease-out;
  transition: .25s ease-out
}

.modal-wrapper.show {
  opacity: 1;
  pointer-events: all
}

.modal-image {
  position: absolute;
  max-width: 80%;
  max-height: 80%;
  min-width: 30%;
  min-height: 30%;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  -o-object-fit: cover;
  object-fit: cover;
  opacity: 0;
  -webkit-transition: .6s ease-out;
  transition: .6s ease-out
}

.modal-image.show {
  opacity: 1
}
</style>
